import { useAgentIsV2 } from '@/pages/avatar/hooks/useAgentIsV2';
import { IAgent } from '@d-id/types';
import { AgentShareModalV1 } from './AgentShareModalV1';
import { AgentShareModalV2 } from './AgentShareModalV2';

interface Props {
    agent?: IAgent;
    open: boolean;
    onClose: () => void;
    errorHandler?: (error: any) => Promise<void>;
}

export const AgentShareModal = (props: Props) => {
    const isV2 = useAgentIsV2(props.agent?.id);

    return isV2 ? <AgentShareModalV2 {...props} /> : <AgentShareModalV1 {...props} />;
};
